/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContactType } from './ContactType';
import {
    ContactTypeFromJSON,
    ContactTypeFromJSONTyped,
    ContactTypeToJSON,
} from './ContactType';

/**
 * A client contact
 * @export
 * @interface ClientContact
 */
export interface ClientContact {
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof ClientContact
     */
    rID: string;
    /**
     * 
     * @type {Date}
     * @memberof ClientContact
     */
    createdAtUtc: Date;
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof ClientContact
     */
    createdByUserRID: string;
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof ClientContact
     */
    clientRID: string;
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof ClientContact
     */
    actorRID: string;
    /**
     * 
     * @type {ContactType}
     * @memberof ClientContact
     */
    contactType?: ContactType;
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof ClientContact
     */
    metadataSchemaRID?: string;
    /**
     * 
     * @type {object}
     * @memberof ClientContact
     */
    metadata?: object;
}

/**
 * Check if a given object implements the ClientContact interface.
 */
export function instanceOfClientContact(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "rID" in value;
    isInstance = isInstance && "createdAtUtc" in value;
    isInstance = isInstance && "createdByUserRID" in value;
    isInstance = isInstance && "clientRID" in value;
    isInstance = isInstance && "actorRID" in value;

    return isInstance;
}

export function ClientContactFromJSON(json: any): ClientContact {
    return ClientContactFromJSONTyped(json, false);
}

export function ClientContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientContact {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rID': json['RID'],
        'createdAtUtc': (new Date(json['createdAtUtc'])),
        'createdByUserRID': json['createdByUserRID'],
        'clientRID': json['clientRID'],
        'actorRID': json['actorRID'],
        'contactType': !exists(json, 'contactType') ? undefined : ContactTypeFromJSON(json['contactType']),
        'metadataSchemaRID': !exists(json, 'metadataSchemaRID') ? undefined : json['metadataSchemaRID'],
        'metadata': !exists(json, 'metadata') ? undefined : json['metadata'],
    };
}

export function ClientContactToJSON(value?: ClientContact | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'RID': value.rID,
        'createdAtUtc': (value.createdAtUtc.toISOString()),
        'createdByUserRID': value.createdByUserRID,
        'clientRID': value.clientRID,
        'actorRID': value.actorRID,
        'contactType': ContactTypeToJSON(value.contactType),
        'metadataSchemaRID': value.metadataSchemaRID,
        'metadata': value.metadata,
    };
}

